import { StoreBuTypeEnum } from '@inter-ikea-kompis/enums';
import type { IStore } from '@inter-ikea-kompis/types';

import ServiceFetch from '../../utilities/ServiceFetch.js';
import type IDexfStoreResponse from './types/IDexfStoreResponse.js';
import type IDexfStoreResponseItem from './types/IDexfStoreResponseItem.js';

/**
 * This class is used for fetching a list of stores for a market.
 */
export default class DexfStoreService {
	private endpoint: string;
	private dexfApiKey: string;

	/**
	 * Constructor.
	 *
	 * @param options Options.
	 * @param options.endpoint Endpoint.
	 * @param options.dexfApiKey DEXF Api ket.
	 */
	constructor(options: { endpoint: string; dexfApiKey: string }) {
		this.endpoint = options.endpoint;
		this.dexfApiKey = options.dexfApiKey;
	}

	/**
	 * Returns stores from a retail unit/market.
	 *
	 * @returns Promise.
	 */
	public async getStores(): Promise<IStore[]> {
		const options = {
			credentials: <RequestCredentials>'same-origin',
			headers: {
				'dexf-api-key': this.dexfApiKey
			}
		};

		const response = <IDexfStoreResponse>await ServiceFetch.json(this.endpoint, options);

		if (!response) {
			return [];
		}
		const stores: IStore[] = [];
		for (const store of response.stores) {
			// Filtering the store types.
			if (
				store.buType === StoreBuTypeEnum.store ||
				store.buType === StoreBuTypeEnum.office ||
				store.buType === StoreBuTypeEnum.smallStore ||
				store.buType === StoreBuTypeEnum.shop
			) {
				stores.push(this.parseStoreItem(store));
			}
		}

		return stores;
	}

	/**
	 * Parses store data.
	 *
	 * @param store Response store.
	 * @returns Item string.
	 */
	private parseStoreItem(store: IDexfStoreResponseItem): IStore {
		return {
			id: store.code,
			name: store.storeText,
			location: {
				latitude: store.latitude,
				longitude: store.longitude
			}
		};
	}
}
